import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolAssetsAction } from '../symbolAssets.action';
import { SymbolAssetsTranslator } from '../symbolAssets.translator';

type IDependencies = IClientApiDependencySegment;

export const loadSymbolAssetsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAssetsAction.load.started),
  mergeMap((params) => {
    return dependencies.api.getSymbolAssets(params).pipe(
      mergeMap((response) => {
        return [
          SymbolAssetsAction.load.done({ params, result: SymbolAssetsTranslator.fromApi(response.assets) }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolAssetsAction.load.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
